import React from 'react';
export function ThumbsUpIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.555 2.168a1 1 0 00-1.45.385L6.383 10H3a2 2 0 00-2 2v8a2 2 0 002 2h16.153a2 2 0 001.973-1.671l1.666-10A2 2 0 0020.82 8H15V5.535a2 2 0 00-.89-1.664l-2.555-1.703zM8 20h11.153l1.667-10H14a1 1 0 01-1-1V5.535L11.388 4.46 8 11.236V20zm-5-8h3v8H3v-8z"
  }));
}